import { css } from '@/styled-system/css';

export const formFieldStyles = css.raw({
  '& > [data-c11n-component="Label"]': {
    display: 'block',
    marginBlockEnd: 'tightest',
  },

  '& > [data-c11n-component="FormHelp"]': {
    marginBlockStart: 'tightest',
  },
});
